module.exports = __webpack_public_path__ + "img/lista_espera.da75edcc.svg";